import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// cora web components
import withRouter from "../../coraWebComponents/utils/withRouter";
import Button from "../../coraWebComponents/buttons/Button";


class Uvod extends React.Component {
  render() {
    const { className, cancel, moveNext } = this.props;

    return (
      <div className={`row m-0 ${className}`}>
        <div className="col-8 offset-2 p-0 forWeb">
          <div className="card formular">
            <div className="form-body">
              <div className="card-title">
                <div>Vytvorenie žiadosti</div>
              </div>

              {/* BUTTONS */}
              <div className="k-form-field flexGroup">
                <Button primary label="Zrusiť" onClick={cancel} />
                <Button label="Ďalej" onClick={moveNext} primary />
              </div>
            </div>
          </div>
        </div>

        <div className="col p-0 forMobile">
          <div className="card formular">
            <div className="form-body">
              <div className="card-title">
                <div>Úvod</div>
              </div>

              {/* BUTTONS */}
              <div className="k-form-field flexGroup">
                <Button primary label="Zrusiť" onClick={cancel} />
                <Button label="Ďalej" onClick={moveNext} primary />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

Uvod.propTypes = {
  moveNext: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Uvod));
